// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useCallback, useState } from "react";
import { DndContext, DragOverlay, closestCenter } from "@dnd-kit/core";
import {
  restrictToVerticalAxis,
  restrictToParentElement,
} from "@dnd-kit/modifiers";

import {
  SortOptions as StyledSortOptions,
  SortHeader,
  Heading,
  SubHeading,
} from "./styles";
import SortableList from "./SortableList";
import OutsideClickHandler from "src/components/OutsideClickHandler";
import SortableItem from "./SortableItem";

type Props = {
  processLabels: Object,
  fields: Object,
  outerRef: any,
  sort: Array<string>,
  clearSort: Function,
  handleSort: Function,
  handleClose: Function,
};

const SortOptions = ({
  sort,
  processLabels,
  fields,
  clearSort,
  handleSort,
  outerRef,
  handleClose,
}: Props) => {
  const [activeId, setActiveId] = useState<string | null>(null);
  const handleClickOutside = useCallback(
    (event: any) => {
      if (outerRef && !outerRef.current.contains(event.target)) {
        handleClose();
      }
    },
    [outerRef, handleClose],
  );

  const handleDragStart = useCallback((event: any) => {
    setActiveId(event?.active?.id);
  }, []);

  const handleDragEnd = useCallback(
    (event: any) => {
      handleSort(event);
      setActiveId(null);
    },
    [handleSort],
  );

  return (
    <OutsideClickHandler onClickOutside={handleClickOutside}>
      <StyledSortOptions>
        <Heading>{i18n.t(k.SORTED_BY)}</Heading>
        <SubHeading>{i18n.t(k.TO_ARRANGE_DRAG_UP_OR_DOWN)}</SubHeading>
        <SortHeader>
          <SubHeading>{i18n.t(k.FILTER_NAME)}</SubHeading>
          <SubHeading>{i18n.t(k.ORDER)}</SubHeading>
        </SortHeader>
        <DndContext
          collisionDetection={closestCenter}
          onDragStart={handleDragStart}
          onDragEnd={handleDragEnd}
          modifiers={[restrictToVerticalAxis, restrictToParentElement]}
        >
          <SortableList
            items={sort}
            processLabels={processLabels}
            fields={fields}
            clearSort={clearSort}
          />

          <DragOverlay>
            {activeId != null && (
              <SortableItem
                column={activeId}
                processLabels={processLabels}
                fields={fields}
                clearSort={clearSort}
              />
            )}
          </DragOverlay>
        </DndContext>
      </StyledSortOptions>
    </OutsideClickHandler>
  );
};

export default SortOptions;
